(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  function loadProductRecommendations() {
    const sprSection = document.querySelector('.product-recommendations');
    const { limit, url } = sprSection.dataset;

    fetch(sprSection.dataset.url)
      .then((response) => {
        if (!response.ok) { throw response };
        return response.text();
      })
      .then((html) => {
        const div = document.createElement('div');
        const colClass = new Map([['2', 'half'], ['3', 'third'], ['4', 'quarter'], ['5', 'fifth']]);

        div.innerHTML = html;
        div.querySelectorAll('.prod-block').forEach((el) => {
          el.classList.remove('half', 'third', 'quarter', 'fifth');
          el.classList.add(colClass.get(limit));
        });
        sprSection.parentElement.innerHTML = div.querySelector('.product-recommendations').innerHTML;

        window.theme.initAnimateOnScroll();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  document.addEventListener('shopify:section:load', (e) => {
    const sectionEl = document.querySelector('.product-recommendations');

    if (sectionEl && sectionEl.dataset.sectionId === e.detail.sectionId) {
      loadProductRecommendations();
      window.dispatchEvent(new CustomEvent('checkcaptionheights'));
    }
  });

  document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class LoadMedia extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const deferredMediaBtn = this.closest('.video-section').querySelector('.js-load-media');
      button.addEventListener('click', () => deferredMediaBtn.click());
    }
  }
  customElements.define('load-media', LoadMedia);

  } catch(e) { console.error(e); }
})();
})();
